import { Injectable, NgZone } from '@angular/core';
import { BehaviorSubject, fromEvent, Observable } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class ConnectivityService {
  private readonly online$ = new BehaviorSubject<boolean>(this.readInitialOnlineState());
  readonly isOnline$: Observable<boolean> = this.online$.asObservable().pipe(distinctUntilChanged());

  constructor(private readonly zone: NgZone) {
    if (typeof window === 'undefined') return;
    fromEvent(window, 'online').subscribe(() => this.zone.run(() => this.online$.next(true)));
    fromEvent(window, 'offline').subscribe(() => this.zone.run(() => this.online$.next(false)));
  }

  get isOnline(): boolean {
    return this.online$.value;
  }

  private readInitialOnlineState(): boolean {
    if (typeof navigator === 'undefined') return true;
    return navigator.onLine !== false;
  }
}
